import {
	ActivateProductionSpaceCategoryMutation,
	ActivateProductionSpaceTypeMutation,
	ClearSpaceDimensionOverrideMutation,
	CommitSpaceRebalanceMutation,
	DeactivateProductionSpaceCategoryMutation,
	DeactivateProductionSpaceTypeMutation,
	DeleteProductionSpaceCategoryMutation,
	DeleteProductionSpaceTypeMutation,
	MergeProductionSpaceCategoryMutation,
	MergeProductionSpaceTypeMutation,
	SetSpaceDimensionOverrideMutation
} from "~/gql/mutations/produce/productionSpacePlanning.generated";
import {
	GetEffectiveSpaceCategoryDimensionsQuery,
	GetPlanBuilderSpacePreviewQuery,
	GetProductionSpaceCategoriesQuery,
	GetProductionSpaceCategoryQuery,
	GetProductionSpaceTypeQuery,
	GetProductionSpaceTypesQuery,
	GetResolvedSpaceCapacityQuery,
	SpaceUtilizationAllSitesQuery,
	SpaceUtilizationDrilldownQuery,
	SpaceUtilizationPreviewQuery,
	SpaceUtilizationQuery
} from "~/gql/queries/produce/productionSpacePlanning.generated";

export const produceSpacePlanningEndpoints = {
	ActivateProductionSpaceCategory: {
		invalidatesTags: ["ProductionSpaceCategory"] as AddTagTypes,
		transformResponse: (res: ActivateProductionSpaceCategoryMutation) => res
	},
	ActivateProductionSpaceType: {
		invalidatesTags: ["ProductionSpaceType"] as AddTagTypes,
		transformResponse: (res: ActivateProductionSpaceTypeMutation) => res
	},
	ClearSpaceDimensionOverride: {
		invalidatesTags: ["ProductionSpaceCategory", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: ClearSpaceDimensionOverrideMutation) => res
	},
	CommitSpaceRebalance: {
		invalidatesTags: ["SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: CommitSpaceRebalanceMutation) => res
	},
	DeactivateProductionSpaceCategory: {
		invalidatesTags: ["ProductionSpaceCategory"] as AddTagTypes,
		transformResponse: (res: DeactivateProductionSpaceCategoryMutation) => res
	},
	DeactivateProductionSpaceType: {
		invalidatesTags: ["ProductionSpaceType"] as AddTagTypes,
		transformResponse: (res: DeactivateProductionSpaceTypeMutation) => res
	},
	DeleteProductionSpaceCategory: {
		invalidatesTags: ["ProductionSpaceCategory"] as AddTagTypes,
		transformResponse: (res: DeleteProductionSpaceCategoryMutation) => res
	},
	DeleteProductionSpaceType: {
		invalidatesTags: ["ProductionSpaceType"] as AddTagTypes,
		transformResponse: (res: DeleteProductionSpaceTypeMutation) => res
	},
	GetProductionSpaceCategories: {
		providesTags: ["ProductionSpaceCategory"] as AddTagTypes,
		transformResponse: (res: GetProductionSpaceCategoriesQuery) => res
	},
	GetEffectiveSpaceCategoryDimensions: {
		providesTags: ["ProductionSpaceCategory"] as AddTagTypes,
		transformResponse: (res: GetEffectiveSpaceCategoryDimensionsQuery) => res
	},
	GetPlanBuilderSpacePreview: {
		providesTags: ["SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: GetPlanBuilderSpacePreviewQuery) => res
	},
	GetProductionSpaceCategory: {
		providesTags: ["ProductionSpaceCategory"] as AddTagTypes,
		transformResponse: (res: GetProductionSpaceCategoryQuery) => res
	},
	GetProductionSpaceType: {
		providesTags: ["ProductionSpaceType"] as AddTagTypes,
		transformResponse: (res: GetProductionSpaceTypeQuery) => res
	},
	GetProductionSpaceTypes: {
		providesTags: ["ProductionSpaceType"] as AddTagTypes,
		transformResponse: (res: GetProductionSpaceTypesQuery) => res
	},
	MergeProductionSpaceCategory: {
		invalidatesTags: ["ProductionSpaceCategory", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: MergeProductionSpaceCategoryMutation) => res
	},
	MergeProductionSpaceType: {
		invalidatesTags: ["ProductionSpaceType"] as AddTagTypes,
		transformResponse: (res: MergeProductionSpaceTypeMutation) => res
	},
	SetSpaceDimensionOverride: {
		invalidatesTags: ["ProductionSpaceCategory", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: SetSpaceDimensionOverrideMutation) => res
	},
	GetResolvedSpaceCapacity: {
		providesTags: ["SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: GetResolvedSpaceCapacityQuery) => res
	},
	SpaceUtilization: {
		providesTags: ["SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: SpaceUtilizationQuery) => res
	},
	SpaceUtilizationAllSites: {
		providesTags: ["SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: SpaceUtilizationAllSitesQuery) => res
	},
	SpaceUtilizationDrilldown: {
		providesTags: ["SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: SpaceUtilizationDrilldownQuery) => res
	},
	SpaceUtilizationPreview: {
		providesTags: ["SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: SpaceUtilizationPreviewQuery) => res
	}
};
